import AuthClientStore from "../../auth/client-store/auth-client-store.ts";
import { ApiMethod, ApiResponseType } from "../types.ts";
import { ApiResponse } from "../../../interface/ApiResponse.ts";
import { parseResponseBody } from "../payload.ts";

const sendRequest = async (
    method: ApiMethod,
    path: string,
    body?: any,
    authToken?: string | null,
    init?: RequestInit,
) => {
    let responseObject = {
        status: 0,
        payload: null
    };
    const urlencoded = new URLSearchParams();
    if (body) {
        Object.entries(body).map((item, key) => {
            if (item[1] === null) {
                item[1] = '';
            }
            if (typeof item[1] === 'object') {
                if (item[1].length > 0) {
                    item[1].map(item1Part => {
                        urlencoded.append(item[0] + '[]', item1Part);
                    });
                } else {
                    urlencoded.append(item[0] + '[]', '');
                }
            } else {
                urlencoded.append(item[0], item[1]);
            }
        });
    }
    let response;
    try {
        response = await fetch(process.env.REACT_APP_FPSB_PORTAL_BASE_URL + path, {
            method,
            ...(body && { body: urlencoded }),
            ...init,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                ...(authToken && { 'X-Authorization': `Bearer ${authToken}` }),
                ...init?.headers,
            },
        }).then(async response => {
            responseObject.status = response.status;
            // Parsed once here, whatever the content type says (see payload.ts).
            return parseResponseBody(await response.text());
        }).then((data):ApiResponse => {
            if (responseObject.status === 400) {
                return {
                    type: ApiResponseType.FORM_INVALID,
                    payload: data,
                }
            } else if (`${responseObject.status}`.startsWith("4")) {
                return {
                    type: ApiResponseType.CLIENT_ERROR,
                    payload: data,
                }
            } else if (`${responseObject.status}`.startsWith("5")) {
                return {
                    type: ApiResponseType.SERVER_ERROR,
                    payload: data,
                }
            }

            return {
                type: ApiResponseType.OK,
                payload: data,
            }
        });
    } catch (error) {
        // Same shape as a backend error body, so callers need no special case.
        response = {
            type: ApiResponseType.SERVER_ERROR,
            payload: {
                errors: {
                    'general_error': 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
                }
            },
        }
    }
    return response;
};

const sendProtectedRequest = (
    method: ApiMethod,
    path: string,
    // eslint-disable-next-line
    body?: any,
    refreshToken?: string,
    init?: RequestInit,
): Promise<ApiResponse> => {
    const authToken = refreshToken
        ? AuthClientStore.getAccessToken()?.refreshToken
        : AuthClientStore.getAccessToken()?.accessToken;
    if (!authToken) {
        throw new Error("No auth token found");
    }

    return sendRequest(method, path, body, authToken, init);
};

export const useApi = () => {
    return { sendRequest, sendProtectedRequest };
};
